import React, { useState } from 'react';
import { Player, PlayerEvent } from '@lottiefiles/react-lottie-player';
import { cn } from '@/utils/styles';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';

interface GutOralCardsLgProps {
  mainText: string;
  isMainTextPercentage?: boolean;
  subText: string;
  subTextColor?: string;
  title?: string;
  footer?: string;
  fallBackVdo: string;
  videoSrc?: any;
  onClick?: () => void;
  'data-testid'?: string;
}

export const GutOralCardsLg: React.FC<GutOralCardsLgProps> = ({
  title,
  isMainTextPercentage,
  mainText,
  subText,
  subTextColor,
  videoSrc,
  fallBackVdo,
  footer,
  onClick,
  'data-testid': testId,
}) => {
  const [isS3Loaded, setIsS3Loaded] = useState(false);

  const handleOnEvent = (e: PlayerEvent) => {
    if (e === 'load') {
      setIsS3Loaded(true);
    }
  };

  return (
    <div
      data-testid={testId}
      onClick={onClick}
      className="w-full h-full border-[1.6px] rounded-lg border-stroke-static cursor-pointer select-none"
    >
      <h2 
        data-testid={`${testId}-title`}
        className="w-full text-center typography-h2 text-primary mt-8 mb-4"
      >
        {title}
      </h2>
      {videoSrc && (
        <div 
          data-testid={`${testId}-videoContainer`}
          className="h-[20rem] relative"
        >
          <div 
            data-testid={`${testId}-videoOverflow`}
            className="absolute inset-0 overflow-hidden"
          >
            {!isS3Loaded && (
              <Player
                data-testid={`${testId}-fallbackVideoPlayer`}
                autoplay
                loop
                src={fallBackVdo}
                className="rounded-lg object-cover"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: '100%',
                }}
              />
            )}
            <Player
              data-testid={`${testId}-videoPlayer`}
              autoplay
              loop
              src={videoSrc}
              className="rounded-lg object-cover"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                display: isS3Loaded ? 'block' : 'none',
              }}
              onEvent={handleOnEvent}
            />
          </div>
          <div 
            data-testid={`${testId}-textContent`}
            className="absolute inset-0 flex flex-col justify-center items-center"
          >
            <p
              data-testid={`${testId}-mainText`}
              className={cn(
                'dark text-primary font-serif',
                isMainTextPercentage ? 'typography-num-large' : 'typography-d1',
              )}
            >
              {mainText}
            </p>
            <p
              data-testid={`${testId}-subText`}
              className="dark typography-body text-primary"
              style={{ color: subTextColor }}
            >
              {subText}
            </p>
          </div>
        </div>
      )}
      <p 
        data-testid={`${testId}-footer`}
        className="typography-body text-secondary px-8 mb-8 line-clamp-2 sm:line-clamp-3"
      >
        {footer}
        <ChevronRightIcon 
          data-testid={`${testId}-chevron`}
          className="inline ml-1 pb-0.5" 
        />
      </p>
    </div>
  );
};
